<!-- Filter bar -->
<div class="battles-filter-bar" *ngIf="battles.length > 0 || battlesSearch || battlesTypeFilter !== 'all' || battlesSideFilter !== 'all' || battlesDateFrom || battlesDateTo">
  <input
    class="battles-search-input"
    type="text"
    placeholder="Search opponent, fleet, or result (win/loss/draw)…"
    [(ngModel)]="battlesSearch"
    (ngModelChange)="onBattlesFilterChange()"
  />
  <input
    class="battles-date-input"
    type="date"
    title="From date"
    [(ngModel)]="battlesDateFrom"
    [max]="battlesDateTo || undefined"
    (ngModelChange)="onBattlesFilterChange()"
  />
  <span class="battles-date-sep">–</span>
  <input
    class="battles-date-input"
    type="date"
    title="To date"
    [(ngModel)]="battlesDateTo"
    [min]="battlesDateFrom || undefined"
    (ngModelChange)="onBattlesFilterChange()"
  />
  <select class="battles-type-select" [(ngModel)]="battlesResultFilter" (ngModelChange)="onBattlesFilterChange()">
    <option value="all">All Results</option>
    <option value="win">Wins</option>
    <option value="loss">Losses</option>
    <option value="draw">Draws</option>
  </select>
  <button class="battles-reset-btn" type="button" (click)="resetBattlesFilters()">Reset Filters</button>
  <select class="battles-type-select" [(ngModel)]="battlesTypeFilter" (ngModelChange)="onBattlesFilterChange()">
    <option value="all">All Battles</option>
    <option value="pvp">PVP</option>
    <option value="tournament">Tournament ★</option>
    <option value="draw">Draws</option>
    <option *ngFor="let t of extraBattleTypes" [value]="t">{{ t }}</option>
  </select>
  <select class="battles-type-select" [(ngModel)]="battlesSideFilter" (ngModelChange)="onBattlesFilterChange()">
    <option value="all">All Sides</option>
    <option value="attack">Attack</option>
    <option value="defense">Defense</option>
  </select>
  <button class="battles-hitlist-btn" type="button" *ngIf="hasHitList" (click)="openHitList()" title="View your hit list of beatable targets">🎯 Hit List</button>
  <button class="battles-add-player-btn" type="button" *ngIf="hasHitList" (click)="openAddPlayerModal()" title="Hitlist player">＋ Hitlist player</button>
  <span class="battles-count">
    <span class="spinner battles-spinner" *ngIf="loading" title="Loading battle history…"></span>
    <ng-container *ngIf="!loading">{{ filteredBattles.length }} of {{ battles.length }} battle{{ battles.length !== 1 ? 's' : '' }}</ng-container>
  </span>
</div>

<div class="battles-toast" *ngIf="addPlayerSuccessMessage">{{ addPlayerSuccessMessage }}</div>

<div class="tab-loading-area" *ngIf="loading && battles.length === 0">
  <div class="spinner-lg"></div>
  <span>Loading battle history…</span>
</div>
<div class="error-msg" *ngIf="error && !loading">{{ error }}</div>

<div class="battles-placeholder" *ngIf="!loading && !error && battles.length === 0">
  No battle history found.
</div>
<div class="battles-placeholder" *ngIf="battles.length > 0 && filteredBattles.length === 0">
  No battles match the current filter.
</div>

<div class="battle-table-wrap" *ngIf="battlesByDay.length > 0">
  <table class="battle-table">
    <thead>
      <tr>
        <th class="bt-col-add"></th>
        <th class="bt-col-result">Result</th>
        <th class="bt-col-role">Type</th>
        <th class="bt-col-opponent">Opponent</th>
        <th class="bt-col-trophies">Trophies</th>
        <th class="bt-col-rewards">Rewards</th>
        <th class="bt-col-league">League</th>
        <th class="bt-col-date">Date</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let dayGroup of battlesByDay">
        <tr class="battle-day-row" [class.battle-day-today]="dayGroup.day === todayDayKey()">
          <td colspan="8" class="battle-day-label">{{ dayGroup.day }}
            <span *ngIf="dayGroup.day === todayDayKey()" class="battle-day-marker">Today</span>
          </td>
        </tr>
        <tr *ngFor="let b of dayGroup.battles"
            [class.battle-win]="battleResult(b) === 'win'"
            [class.battle-loss]="battleResult(b) === 'loss'"
            [class.battle-draw]="battleResult(b) === 'draw'"
            [class.battle-pvp]="(b.battleType ? b.battleType.toUpperCase() : '') === 'PVP' && !b.isStarBattle"
            [class.battle-tournament]="b.isStarBattle"
            [class.battle-engagement]="b.battleType ? b.battleType.toLowerCase().includes('engage') : false"
            >
        <td class="bt-col-add">
          <button
            *ngIf="hasHitList && canShowAddToHitList(b)"
            class="bt-add-hitlist-btn"
            title="Add to Hit List"
            (click)="addOpponentToHitList(b, $event)">+
          </button>
          <button
            *ngIf="hasHitList && canShowRemoveFromHitList(b)"
            class="bt-remove-hitlist-btn"
            title="Remove from Hit List"
            (click)="removeOpponentFromHitList(b, $event)">−
          </button>
        </td>
        <td class="bt-col-result">
          <span class="battle-badge"
                [class.badge-win]="battleResult(b) === 'win'"
                [class.badge-loss]="battleResult(b) === 'loss'"
                [class.badge-draw]="battleResult(b) === 'draw'"
                [class.badge-unknown]="battleResult(b) === 'unknown'">
            {{ battleResult(b) === 'win' ? 'WIN' : battleResult(b) === 'loss' ? 'LOSS' : battleResult(b) === 'draw' ? 'DRAW' : '—' }}
          </span>
        </td>
        <td class="bt-col-role">
          <span class="bt-role-badge" [class.bt-role-atk]="battleRole(b) === 'attack'" [class.bt-role-def]="battleRole(b) === 'defense'">
            {{ battleRole(b) === 'attack' ? 'ATK' : 'DEF' }}
          </span>
        </td>
        <td class="bt-col-opponent">
          <div class="bt-opponent-name">
            {{ battleOpponent(b) }}
            <span class="bt-opponent-trophies" *ngIf="battleOpponentTrophiesKnown(b)">(🏆 {{ battleOpponentTrophiesLabel(b) }})</span>
          </div>
          <div class="bt-opponent-fleet" *ngIf="battleOpponentFleet(b)">{{ battleOpponentFleet(b) }}</div>
        </td>
        <td class="bt-col-trophies">
          <ng-container *ngIf="b.isStarBattle; else trophyChange">
            <span class="bt-star-badge"
                  [class.bt-star-won]="battleResult(b) === 'win' && b.starsWon > 0">
              ★ {{ battleResult(b) === 'win' ? b.starsWon || '—' : '—' }}
            </span>
          </ng-container>
          <ng-template #trophyChange>
            <span *ngIf="battleTrophyChange(b) !== null"
                  [class.trophy-pos]="(battleTrophyChange(b) ?? 0) > 0"
                  [class.trophy-neg]="(battleTrophyChange(b) ?? 0) < 0">
              {{ (battleTrophyChange(b) ?? 0) > 0 ? '+' : '' }}{{ battleTrophyChange(b) }}
            </span>
            <span *ngIf="battleTrophyChange(b) === null">—</span>
          </ng-template>
        </td>
        <td class="bt-col-rewards">{{ battleRewardsSummary(b) || '—' }}</td>
        <td class="bt-col-league">{{ b.leagueType || '—' }}</td>
        <td class="bt-col-date">{{ b.battleDate ? (b.battleDate | date:'MMM d, y HH:mm') : '—' }}</td>
      </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<!-- Infinite scroll trigger -->
<div #scrollSentinel class="battles-scroll-sentinel" *ngIf="hasMoreBattles">
  <span class="spinner battles-spinner"></span>
</div>

<!-- Back to top (relocated to document.body in ngAfterViewInit — see component) -->
<button
  #backToTopBtn
  class="battles-back-to-top"
  type="button"
  [class.visible]="showBackToTop"
  (click)="scrollToTop()"
  title="Back to top"
  aria-label="Back to top"
>↑</button>

<!-- Hit List Modal -->
<div class="hit-list-backdrop" *ngIf="showHitList" (click)="closeHitList()">
  <div class="hit-list-panel" (click)="$event.stopPropagation()">
    <div class="hit-list-panel-header">
      <span class="hit-list-panel-title">🎯 Hit List</span>
      <button class="hit-list-close-btn" type="button" (click)="closeHitList()" title="Close">✕</button>
    </div>
    <div class="hit-list-panel-body">
      <app-hit-list #hitListRef [userId]="userId" [isModalMode]="true" />
    </div>
  </div>
</div>

<!-- Add Player to Hit List Modal -->
<div class="add-player-backdrop" *ngIf="showAddPlayerModal" (click)="closeAddPlayerModal()">
  <div class="add-player-modal" (click)="$event.stopPropagation()">
    <div class="add-player-header">
      <span>Hitlist player</span>
      <button type="button" class="modal-close" (click)="closeAddPlayerModal()">✕</button>
    </div>
    <div class="add-player-body">
      <label>
        Search player
        <input type="search" [(ngModel)]="addPlayerQuery" (input)="searchAddPlayer()" placeholder="Name or ID" />
      </label>
      <div class="add-player-status">
        <span class="spinner" *ngIf="addPlayerLoading"></span>
        <span class="error-msg" *ngIf="addPlayerError">{{ addPlayerError }}</span>
      </div>
      <ul class="add-player-results" *ngIf="addPlayerResults.length > 0">
        <li *ngFor="let player of addPlayerResults" (click)="addPlayerToHitListFromSearch(player)">
          <span class="player-name">{{ player.userName }}</span>
          <span class="player-id">({{ player.userId }})</span>
          <span class="player-alliance" *ngIf="player.allianceId">{{ player.allianceId }}</span>
        </li>
      </ul>
      <div *ngIf="!addPlayerLoading && !addPlayerError && addPlayerQuery && addPlayerResults.length === 0" class="add-player-empty">
        No players found.
      </div>
    </div>
  </div>
</div>
